import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** ADD CENTER DETAILS START *********************** */
export const centerDetailsAdd = (addData: any) => {
	const data = {
		AddCenterDetailsToken: addData,
	};
	const url = `${API_URL}addCenterDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD CENTER DETAILS END *********************** */

/** ***************** UPDATE CENTER DETAILS START *********************** */

export const centerDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateCenterDetailsToken: updateData,
	};
	const url = `${API_URL}updateCenterDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE CENTER DETAILS END *********************** */

/** ***************** GET CENTER DETAILS START *********************** */
export const centerListGet = (listData: any) => {
	const data = {
		GetCenterListToken: listData,
	};
	const url = `${API_URL}getCenterList`;
	return makeApiCall(url, data);
};
/** ***************** GET CENTER DETAILS END *********************** */

/** ***************** FETCH CENTER DETAILS START *********************** */
export const centerDetailsFetch = (fetchData: any) => {
	const data = {
		FetchCenterDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchCenterDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH CENTER DETAILS END *********************** */

/** ***************** DELETE CENTER DETAILS START *********************** */
export const centerDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteCenterDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteCenterDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE CENTER DETAILS END *********************** */
